'use client'

import { Switch } from '@/components/ui/switch'
import { AccessControl } from '@/features/access-control/access-control'
import { SuperUserAccessControlRule } from '@/features/access-control/access-control-rules'
import { useAppCustomizationStore } from '@/features/app-customization/app-customization-store'

export const AppCustomizationSection = () => {
    const showEditorProjectsInSidebar = useAppCustomizationStore((s) => s.showEditorProjectsInSidebar)
    const setShowEditorProjectsInSidebar = useAppCustomizationStore((s) => s.setShowEditorProjectsInSidebar)

    return (
        <div className="flex flex-col divide-y divide-stone-100 rounded-lg border border-stone-100">
            {/* Editor Projects toggle is super-user only while Studio is hidden from end users. */}
            <AccessControl rule={SuperUserAccessControlRule}>
                <SettingRow
                    label="Show editor projects in sidebar"
                    description="Display your editor projects in the left sidebar"
                    checked={showEditorProjectsInSidebar}
                    onCheckedChange={setShowEditorProjectsInSidebar}
                />
            </AccessControl>
        </div>
    )
}

function SettingRow({
    label,
    description,
    checked,
    onCheckedChange,
}: {
    label: string
    description: string
    checked: boolean
    onCheckedChange: (value: boolean) => void
}) {
    return (
        <div className="flex items-start justify-between gap-4 p-4">
            <div className="min-w-0">
                <div className="text-[14px] font-medium text-[#171717]">{label}</div>
                <div className="text-[13px] text-[#6B7280] mt-0.5">{description}</div>
            </div>
            <Switch checked={checked} onCheckedChange={onCheckedChange} />
        </div>
    )
}
